var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversioLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 370.73 102.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74,17.2c-10.48,0-16.83,4.39-21.25,10.9l-.06-.05C50,31.14,36.26,53.8,25.88,53.19c-5.64-.33-9.54-4.68-9.54-10.87v-.17c0-5.83,4-10.6,9.36-10.6,4.06,0,6.63,1.85,8.92,5L46,28.11C42,21.66,35.42,17.42,25.61,17.42,10.51,17.42,0,28.81,0,42.32v.18A24.65,24.65,0,0,0,25,67.32c18.86,0,34.38-24.47,38.84-31.08l.06,0c2.65-3.09,5.21-5,9.18-5,5.66,0,9.54,4.68,9.54,10.86v.18c0,5.83-4,10.6-9.36,10.6-4.06,0-6.62-1.85-8.92-5L52.94,56.41C57,62.86,63.54,67.1,73.34,67.1,88.44,67.1,99,55.71,99,42.19V42A24.66,24.66,0,0,0,74,17.2Z",
    style: {
      fill: "#e20678"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,16c-12.71,0-22.51,7.79-25.52,18.18V17H302.11v4.49a37.38,37.38,0,0,0-19.52-5.46c-6.48,0-11.95,2-15.37,5.63V16.23c-7.94-.36-12.36,3.88-15.1,10.42V17H235.34V32.81C232.59,23.12,225.17,16,212.47,16a23.34,23.34,0,0,0-20.36,11.21l4-10.15h-17.4l-9.18,27.91L160.36,17H142.7l1.63,4.12c-2.8-3.32-7-5.18-12.31-5.18-6.8,0-11.22,3.8-14.31,7.77V17H100.93V64.8h16.78V38.92c0-5.21,3-8,7.06-8s6.72,2.82,6.72,8V64.8h16.78V33.54a24.71,24.71,0,0,0-.18-2.91l13.69,34.53h15.28L189,35.05a27.87,27.87,0,0,0-.63,5.91v.17C188.36,56,199,66,214,66c9.54,0,16.16-3.89,20.76-9.71l-9.28-7.69c-3.44,3.36-6.62,4.86-10.6,4.86-5.21,0-9-2.65-10.33-7.86h30.82V64.8h16.78V50c0-10,4.11-15.1,11.43-15.93,1,8.08,8.07,11,16.83,13.28,5,1.42,7.69,2.21,7.69,4.07v.17c0,1.68-1.33,2.56-4.24,2.56-4.95,0-10.95-1.85-16.43-5.47L261.13,58.8a38.51,38.51,0,0,0,22.61,7.06c9.05,0,15.8-3.32,18.37-9.72V64.8h16.78V48c3,10.33,12.72,18,25.34,18,15.37,0,26.5-11.39,26.5-25v-.18C370.73,27.18,359.69,16,344.41,16ZM204.26,37c.88-5.21,3.88-8.65,8.3-8.65,4.59,0,7.68,3.35,8.3,8.65Zm82-2.47c-5-1.5-7.77-2.39-7.77-4.24v-.18c0-1.32,1.32-2.29,3.88-2.29,3.8,0,9.19,1.67,14.14,4.41l5.56-10.27V44.18C299.67,39,293.57,36.55,286.3,34.51Zm68.09,6.62c0,5.74-3.89,10.6-10,10.6-5.92,0-10.16-4.95-10.16-10.77v-.18c0-5.74,3.89-10.6,10-10.6,5.92,0,10.16,5,10.16,10.78Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.23,98V95a6.56,6.56,0,0,1-5.59,3.35A6.75,6.75,0,0,1,0,91.29v-.05a6.79,6.79,0,0,1,6.6-7.11,6.52,6.52,0,0,1,5.59,3.25V78.59h1.31V98Zm.08-6.82a5.67,5.67,0,0,0-5.53-5.83c-3,0-5.33,2.16-5.33,5.81v0c0,3.57,2.48,5.86,5.33,5.86a5.68,5.68,0,0,0,5.53-5.83Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.48,98V95.77a6.2,6.2,0,0,1-5.2,2.58c-2.53,0-5.24-1.44-5.24-4.26v0c0-2.83,2.42-4.42,5.94-4.42a16.63,16.63,0,0,1,4.5.58v-.58c0-2.75-1.68-4.16-4.48-4.16a9.09,9.09,0,0,0-4.26,1.1l-.48-1.15a11,11,0,0,1,4.82-1.17c3.49,0,5.67,1.81,5.67,5.32V98Zm0-6.63a18.08,18.08,0,0,0-4.6-.61c-2.88,0-4.48,1.28-4.48,3.17V94c0,2,1.87,3.12,3.94,3.12,2.77,0,5.14-1.71,5.14-4.18Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,98.27a3.47,3.47,0,0,1-3.81-3.73V85.65h-2v-1.2h2V80.11H33v4.34h4.76v1.2H33v8.76a2.38,2.38,0,0,0,2.71,2.64,4.63,4.63,0,0,0,2-.48v1.22A5,5,0,0,1,35.5,98.27Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.61,98V95.77a6.18,6.18,0,0,1-5.19,2.58c-2.53,0-5.25-1.44-5.25-4.26v0c0-2.83,2.42-4.42,5.94-4.42a16.63,16.63,0,0,1,4.5.58v-.58c0-2.75-1.68-4.16-4.47-4.16a9.06,9.06,0,0,0-4.26,1.1l-.48-1.15a10.92,10.92,0,0,1,4.82-1.17c3.48,0,5.67,1.81,5.67,5.32V98Zm0-6.63A18.24,18.24,0,0,0,45,90.79c-2.88,0-4.47,1.28-4.47,3.17V94c0,2,1.86,3.12,3.94,3.12,2.77,0,5.14-1.71,5.14-4.18Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.64,101.44V76.78h1.17v24.66Z",
    style: {
      fill: "#e20678"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.61,97.13A6.14,6.14,0,0,0,84.27,95l.9.79a7.09,7.09,0,0,1-5.61,2.56,6.75,6.75,0,0,1-6.66-7.08v-.06c0-3.94,2.77-7.08,6.44-7.08s6.23,3.09,6.23,7.11v.05a4,4,0,0,1,0,.48H74.28A5.39,5.39,0,0,0,79.61,97.13Zm4.55-6.53c-.18-2.74-1.76-5.27-4.87-5.27-2.69,0-4.77,2.26-5,5.27Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,98l-4.8-6-4.79,6H86l5.56-6.92-5.35-6.66h1.63l4.58,5.75L97,84.45h1.57l-5.35,6.63,5.56,7Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,98.35a6.53,6.53,0,0,1-5.6-3.25v7.19h-1.3V84.45h1.3v3a6.57,6.57,0,0,1,5.6-3.36,6.75,6.75,0,0,1,6.6,7.06v0A6.79,6.79,0,0,1,108,98.35Zm5.19-7.11c0-3.57-2.48-5.86-5.33-5.86a5.69,5.69,0,0,0-5.54,5.83v.06a5.67,5.67,0,0,0,5.54,5.83c3,0,5.33-2.16,5.33-5.81Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11,97.13A6.14,6.14,0,0,0,127.77,95l.9.79a7.11,7.11,0,0,1-5.62,2.56,6.74,6.74,0,0,1-6.65-7.08v-.06c0-3.94,2.77-7.08,6.44-7.08s6.23,3.09,6.23,7.11v.05a2.69,2.69,0,0,1,0,.48H117.78A5.39,5.39,0,0,0,123.11,97.13Zm4.55-6.53c-.19-2.74-1.76-5.27-4.87-5.27-2.69,0-4.77,2.26-5,5.27Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73,85.68c-3.14,0-5.88,2.37-5.88,6.79V98h-1.31V84.45h1.31v3.86a6.41,6.41,0,0,1,6-4.07v1.44Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.89,80.91V79.13h1.62v1.78ZM141.05,98V84.45h1.3V98Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.38,98V90c0-2.93-1.52-4.63-4-4.63-2.29,0-4.29,1.76-4.29,4.79V98h-1.3V89.88c0-2.82-1.54-4.55-4-4.55a4.58,4.58,0,0,0-4.34,4.87V98h-1.3V84.45h1.3v2.42A5,5,0,0,1,152,84.13a4.88,4.88,0,0,1,4.58,2.93,5.39,5.39,0,0,1,4.9-2.93c3.22,0,5.22,2.27,5.22,5.67V98Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.92,97.13A6.14,6.14,0,0,0,180.58,95l.91.79a7.12,7.12,0,0,1-5.62,2.56,6.75,6.75,0,0,1-6.66-7.08v-.06c0-3.94,2.77-7.08,6.44-7.08s6.24,3.09,6.24,7.11v.05a2.69,2.69,0,0,1,0,.48H170.6A5.38,5.38,0,0,0,175.92,97.13Zm4.55-6.53c-.18-2.74-1.75-5.27-4.87-5.27-2.69,0-4.76,2.26-5,5.27Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.69,98V90c0-2.79-1.57-4.63-4.31-4.63a4.66,4.66,0,0,0-4.72,4.85V98h-1.3V84.45h1.3V87a5.33,5.33,0,0,1,4.9-2.85c3.44,0,5.43,2.35,5.43,5.59V98Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.87,98.27a3.47,3.47,0,0,1-3.81-3.73V85.65h-2v-1.2h2V80.11h1.31v4.34h4.77v1.2h-4.77v8.76c0,1.94,1.14,2.64,2.72,2.64a4.62,4.62,0,0,0,2-.48v1.22A5,5,0,0,1,203.87,98.27Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,98V95.77a6.18,6.18,0,0,1-5.19,2.58c-2.53,0-5.24-1.44-5.24-4.26v0c0-2.83,2.42-4.42,5.93-4.42a16.58,16.58,0,0,1,4.5.58v-.58c0-2.75-1.67-4.16-4.47-4.16a9.09,9.09,0,0,0-4.26,1.1l-.48-1.15a11,11,0,0,1,4.82-1.17c3.49,0,5.67,1.81,5.67,5.32V98Zm0-6.63a18.17,18.17,0,0,0-4.61-.61c-2.87,0-4.47,1.28-4.47,3.17V94c0,2,1.86,3.12,3.94,3.12,2.77,0,5.14-1.71,5.14-4.18Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,98.27a3.47,3.47,0,0,1-3.81-3.73V85.65h-2v-1.2h2V80.11h1.3v4.34h4.77v1.2H224.5v8.76c0,1.94,1.15,2.64,2.72,2.64a4.66,4.66,0,0,0,2-.48v1.22A5,5,0,0,1,227,98.27Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.82,80.91V79.13h1.63v1.78ZM232,98V84.45h1.31V98Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.11,98.35a7,7,0,0,1-7-7.06v-.05a7,7,0,0,1,7-7.11,6.94,6.94,0,0,1,7,7.06v0A7,7,0,0,1,243.11,98.35Zm5.59-7.11a5.69,5.69,0,0,0-5.59-5.88,5.6,5.6,0,0,0-5.54,5.83v0a5.7,5.7,0,0,0,5.59,5.89,5.6,5.6,0,0,0,5.54-5.84Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.13,98V90c0-2.79-1.57-4.63-4.31-4.63a4.65,4.65,0,0,0-4.71,4.85V98H252.8V84.45h1.31V87A5.3,5.3,0,0,1,259,84.13c3.44,0,5.44,2.35,5.44,5.59V98Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.19,101.44V76.78h1.17v24.66Z",
    style: {
      fill: "#e20678"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34,102.34a10.3,10.3,0,0,1-6.23-2.07l.78-1.07a8.85,8.85,0,0,0,5.48,1.92c3.12,0,5.33-1.78,5.33-5.27v-2A6.8,6.8,0,0,1,293,97a6.43,6.43,0,0,1-6.52-6.39v0A6.46,6.46,0,0,1,293,84.13a6.76,6.76,0,0,1,5.68,3V84.45H300V95.93C300,100.05,297.21,102.34,293.34,102.34Zm5.44-11.79a5.4,5.4,0,0,0-5.62-5.17,5,5,0,0,0-5.25,5.14v.06a5.16,5.16,0,0,0,5.25,5.19c2.82,0,5.62-2.08,5.62-5.17Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.81,85.68c-3.14,0-5.89,2.37-5.89,6.79V98h-1.3V84.45h1.3v3.86a6.42,6.42,0,0,1,6-4.07v1.44Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.29,98.35a7,7,0,0,1-7-7.06v-.05a7,7,0,1,1,14,0v0A7,7,0,0,1,318.29,98.35Zm5.59-7.11a5.69,5.69,0,0,0-5.59-5.88,5.6,5.6,0,0,0-5.54,5.83v0a5.7,5.7,0,0,0,5.59,5.89,5.61,5.61,0,0,0,5.54-5.84Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.48,98.14h-1.12L336.31,86.5l-4.07,11.64h-1.12l-5-13.69h1.47l4.1,11.93,4.1-12h1l4.1,12,4.11-11.93h1.41Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.43,98.27a3.47,3.47,0,0,1-3.81-3.73V85.65h-2v-1.2h2V80.11h1.3v4.34h4.77v1.2h-4.77v8.76c0,1.94,1.15,2.64,2.72,2.64a4.66,4.66,0,0,0,2-.48v1.22A5,5,0,0,1,353.43,98.27Z",
    style: {
      fill: "#322038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.55,98V90c0-2.79-1.57-4.63-4.31-4.63a4.66,4.66,0,0,0-4.72,4.85V98h-1.3V78.59h1.3V87a5.33,5.33,0,0,1,4.9-2.85c3.44,0,5.43,2.35,5.43,5.59V98Z",
    style: {
      fill: "#322038"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "310.5 0 318.89 0 314.69 7.27 310.5 14.53 306.3 7.27 302.11 0 310.5 0",
    style: {
      fill: "#e20678"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversioLogo);
export default __webpack_public_path__ + "static/media/conversio_logo.b05a7c4ff7673c386f21822ced10d981.svg";
export { ForwardRef as ReactComponent };